import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

/**
 * 60-second countdown warning shown before an agent is auto-logged-out for
 * inactivity. See `useAgentSessionTimeout`.
 */
export function SessionTimeoutWarningModal({ open, secondsLeft, onStayLoggedIn }) {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-sm" data-testid="session-timeout-warning-modal" hideClose onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-amber-500" />
            Still there?
          </DialogTitle>
          <DialogDescription>
            You've been inactive for a while. For your security, you'll be logged out in{" "}
            <span className="font-semibold text-foreground" data-testid="session-timeout-countdown">{secondsLeft}</span> second{secondsLeft === 1 ? "" : "s"}.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onStayLoggedIn} className="w-full" data-testid="session-timeout-stay-logged-in-btn">
            Stay logged in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
